module.exports = __webpack_public_path__ + "img/website_design.f8101e4c.svg";